import IconButton from "@mui/material/IconButton";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const previousBtn_ = (theme) => ({
  position: "absolute",
  top: 300,
  zIndex: 1,
  left: 22,
  border: "1px solid white",
  color: "white",
});

const nextBtn_ = (theme) => ({
  position: "absolute",
  top: 300,
  zIndex: 1,
  right: 22,
  border: "1px solid white",
  color: "white",
});

export function PreviousBtn({ targetPhoto, currentIndex, onClick }) {
  const isVisible = !!targetPhoto && targetPhoto.length && currentIndex > 0;

  return (
    <span>
      {isVisible && (
        <IconButton size="small" sx={previousBtn_} onClick={onClick}>
          <NavigateBeforeIcon />
        </IconButton>
      )}
    </span>
  );
}

export function NextBtn({ targetPhoto, currentIndex, onClick }) {
  const isVisible =
    !!targetPhoto &&
    targetPhoto.length &&
    currentIndex < targetPhoto.length - 1;

  return (
    <span>
      {isVisible && (
        <IconButton size="small" sx={nextBtn_} onClick={onClick}>
          <NavigateNextIcon />
        </IconButton>
      )}
    </span>
  );
}
